var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgTodayLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 286,
    fill: "none",
    viewBox: "0 0 800 286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 286,
    fill: "url(#c)",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M457.198 330.638c2.825-36.754 34.955-64.261 71.768-61.446a66.856 66.856 0 0 1 22.46 5.728c.731-.984 1.464-1.966 2.226-2.922.02-.307.023-.608.045-.915 2.823-36.754 34.953-64.261 71.765-61.446a66.611 66.611 0 0 1 31.937 10.99c8.574-24.938 33.182-41.957 60.743-39.849 17.501 1.34 32.648 10.123 42.567 22.999 12.405-37.778 49.376-63.688 90.858-60.514 34.007 2.603 62.031 24.073 74.61 53.34a66.612 66.612 0 0 1 30.909-4.981c36.812 2.816 64.364 34.893 61.544 71.645-.06.9-.16 1.79-.27 2.68a88.82 88.82 0 0 1 21.88-1.029c48.74 3.73 85.23 46.202 81.5 94.863-3.74 48.662-46.28 85.09-95.03 81.36-1.03-.079-2.04-.201-3.05-.312-11.51 16.586-31.267 26.815-52.871 25.164-15.525-1.187-29.171-8.303-38.907-18.94-28.089 23.439-64.99 36.404-104.375 33.388-26.698-2.042-51.134-11.188-71.656-25.394-13.161 18.359-35.329 29.606-59.521 27.755-22.73-1.738-41.918-14.639-52.619-32.899-12.495 9.297-28.27 14.315-45.028 13.032-33.477-2.563-59.29-29.321-61.576-61.789a67.053 67.053 0 0 1-18.363 1.134c-36.809-2.813-64.364-34.888-61.546-71.642Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.5 45.301 59.79 41l-.066 4.824 4.122-2.793-2.408 4.242 5.01-.644-4.198 2.688L67 50.968l-5.026.519 3.402 3.568-4.703-1.77 1.274 4.669-3.302-3.653L57.5 59l-1.145-4.699-3.302 3.653 1.274-4.669-4.703 1.77 3.402-3.568L48 50.968l4.75-1.651-4.198-2.688 5.01.644-2.408-4.242 4.122 2.793L55.21 41l2.29 4.301Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF820A",
    d: "m363 37.17 1.688-3.17-.049 3.555 3.037-2.058-1.774 3.126 3.691-.475-3.093 1.98 3.5 1.217-3.703.382 2.506 2.63-3.465-1.305.939 3.44-2.433-2.691-.844 3.462-.844-3.462-2.433 2.691.939-3.44-3.465 1.305 2.507-2.63-3.704-.382 3.5-1.217-3.093-1.98 3.692.474-1.775-3.125 3.038 2.058-.05-3.555L363 37.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m604.5 235.301 2.29-4.301-.066 4.824 4.122-2.793-2.408 4.242 5.01-.644-4.198 2.688 4.75 1.651-5.026.519 3.402 3.568-4.703-1.77 1.274 4.669-3.302-3.653L604.5 249l-1.145-4.699-3.302 3.653 1.274-4.669-4.702 1.77 3.401-3.568-5.026-.519 4.75-1.651-4.198-2.688 5.01.644-2.408-4.242 4.123 2.793-.067-4.824 2.29 4.301Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF820A",
    d: "m319.5 226.301 2.29-4.301-.066 4.824 4.122-2.793-2.408 4.242 5.01-.644-4.198 2.688 4.75 1.651-5.026.519 3.402 3.568-4.703-1.77 1.274 4.669-3.302-3.653L319.5 240l-1.145-4.699-3.302 3.653 1.274-4.669-4.702 1.77 3.401-3.568-5.026-.519 4.75-1.651-4.198-2.688 5.01.644-2.408-4.242 4.123 2.793-.067-4.824 2.29 4.301Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M149.266 224.173a91.442 91.442 0 0 0-24.179 9.879c-24.8-39.256-72.805-60.089-120.345-48.226-54.865 13.691-89.825 66.112-83.04 120.815a69.448 69.448 0 0 0-20.505 1.983c-37.236 9.291-59.892 46.99-50.606 84.205 9.286 37.215 46.999 59.849 84.235 50.557a69.342 69.342 0 0 0 22.416-10.056c18.785 18.978 46.81 27.856 74.609 20.919 17.85-4.455 32.71-14.72 43.1-28.263 15.535 7.074 33.473 9.155 51.327 4.699 17.133-4.275 31.523-13.898 41.838-26.637a91.453 91.453 0 0 0 25.37-2.66c48.965-12.218 78.761-61.797 66.549-110.733-12.212-48.937-61.804-78.7-110.769-66.482Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -64.803,
    x2: 817.062,
    y1: -44.627,
    y2: 127.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4658D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 517.5,
    x2: 989.631,
    y1: 291,
    y2: 265.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 265.988,
    x2: -10.109,
    y1: 254.622,
    y2: 272.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E45C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E46C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 286,
    fill: "#fff",
    rx: 20
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 800,
    height: 286,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1 1",
    numOctaves: 3,
    result: "noise",
    seed: 6859,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    in: "coloredNoise1",
    in2: "shape",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.3)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_193_1559"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTodayLarge);
export default __webpack_public_path__ + "static/media/bg-today-large.0ea745fe7292037130ab7dd887e9942b.svg";
export { ForwardRef as ReactComponent };